import { Observable , of, share } from 'rxjs';
import { ICedroServicesLoggable } from './../strategy-pattern-login/iCedroServices-loggable';
import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { HttpService } from '@services/http-service';
import { MessageContextInfoUser } from '@model/webFeeder/message-context-info-user';
import { map } from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class ICedroServicesApiService implements ICedroServicesLoggable {

brokersContextUser: any = [];

  constructor(
    private _configService: ConfigService,
    private _httpService: HttpClient
  ) { }

  contextInfoUser(usermame: string, password: string) {
    if (this.brokersContextUser && Array.isArray(this.brokersContextUser.usersBroker) && this.brokersContextUser.usersBroker.length > 0) {
      return of(this.brokersContextUser);
    } else {
      const params = new MessageContextInfoUser();
      params.usermame = usermame;
      params.password = password;
      const headers: HttpHeaders = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
      return this._httpService
        .post(this._configService.getUrlApiFacade(false, true) + '/services/CedroServices/ContextInfoUser', JSON.stringify(params), { headers })
        .pipe(map(response => {
          console.log(response);
          if (response) {
            this.brokersContextUser = response;
            return this.brokersContextUser;
          }
          return [];
        },

        ),
        share()
        );
    }
  }

  clearContextInfoUser() {
    this.brokersContextUser = [];
  }

}
